
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rddaycxdxrgardwoumjn.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJkZGF5Y3hkeHJnYXJkd291bWpuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA2NTA2MTAsImV4cCI6MjA1NjIyNjYxMH0.mRSa_H7mBdS9mRtOqp1Bz6v12PIbKYLO6zhilOgGMtg";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      storageKey: 'menuify_auth_token',
      flowType: 'pkce',
      detectSessionInUrl: true,
      debug: false, // Désactivé pour éviter les logs encombrants
    }
  }
);
